import React from "react";

export default function ToggleSwitch({ label, checked, onChange, name }) {
  return (
    <label className="flex items-center cursor-pointer gap-3 mt-4">
      <div className="relative">
        <input
          type="checkbox"
          id={name}
          name={name}
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="sr-only"
        />
        <div className={`block w-12 h-7 rounded-full transition ${checked ? "bg-primary" : "bg-gray-300"}`}></div>
        {/* start-1 بدل left-1 عشان نقطة التبديل ترتاح على بداية المسار (تتقلب
            تلقائيًا مع اتجاه اللغة)، و rtl:-translate-x-5 عشان حركة الانزلاق
            (translate-x فيزيائي دايمًا) تتجه ناحية النهاية الصحيحة في
            العربي بدل ما تكمل لنفس الجهة زي الإنجليزي بالظبط. */}
        <div
          className={`dot absolute start-1 top-1 bg-white w-5 h-5 rounded-full transition-transform ${
            checked ? "translate-x-5 rtl:-translate-x-5" : ""
          }`}
        ></div>
      </div>
      <span className="text-gray-700">{label}</span>
    </label>
  );
}
